import axios from "axios";

export const CDNClient = axios.create({
  baseURL: "https://menutranslate.condivision.biz/fl_api_dev/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});